export const LOADING_CRITERION = "LOADING_CRITERION";
export const SAVE_LOADING_CRITERION = "SAVE_LOADING_CRITERION";
export const GET_CRITERION = "GET_CRITERION";
export const FORM_FAIL = "FORM_FAIL";
export const CRITERION_FAIL = "CRITERION_FAIL";
export const LOADING_CRITERION_BY_ID = "LOADING_CRITERION_BY_ID";
export const GET_CRITERION_BY_ID = "GET_CRITERION_BY_ID";